export const LIST_SORT_OPTION_LABELS = {
    DATE_NEWEST: {label: "Data dodania: Od najnowszych", labelShort: "Najnowsze"},
    DATE_OLDEST: {label: "Data dodania: Od najstarszych", labelShort: "Najstarsze"},
    PRICE_CHEAPEST: {label: "Cena: Od najtańszych", labelShort: "Najtańsze"},
    PRICE_MOST_EXPENSIVE: {label: "Cena: Od najdroższych", labelShort: "Najdroższe"},
    AREA_BIGGEST: {label: "Metraż: Od największych", labelShort: "Największe"},
    AREA_SMALLEST: {label: "Metraż: Od najmniejszych", labelShort: "Najmniejsze"}
} as const;
export const LIST_SORT_OPTION_LABELS = {
    DATE_NEWEST: {label: "Data dodania: Od najnowszych", labelShort: "Najnowsze"},
    DATE_OLDEST: {label: "Data dodania: Od najstarszych", labelShort: "Najstarsze"},
    PRICE_CHEAPEST: {label: "Cena: Od najtańszych", labelShort: "Najtańsze"},
    PRICE_MOST_EXPENSIVE: {label: "Cena: Od najdroższych", labelShort: "Najdroższe"},
    AREA_BIGGEST: {label: "Metraż: Od największych", labelShort: "Największe"},
    AREA_SMALLEST: {label: "Metraż: Od najmniejszych", labelShort: "Najmniejsze"}
} as const;
